import { render, staticRenderFns } from "./RetrydoblefactorIcon.vue?vue&type=template&id=1896d34a"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./RetrydoblefactorIcon.vue?vue&type=custom&index=0&blockType=svg&xmlns=http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&width=24&height=24&viewBox=0%200%2024%2024&fill=none&stroke=currentColor&stroke-width=2&stroke-linecap=round&stroke-linejoin=round&class=icon%20icon-tabler%20icons-tabler-outline%20icon-tabler-auth-2fa"
if (typeof block0 === 'function') block0(component)

export default component.exports